// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"da63b45c","71":"e91bff3f","95":"440832fb","113":"6111bbb9","142":"1bfb9342","438":"c90678fb","538":"a908c20f","592":"84b15d03","648":"3f5b6b20","758":"52317edc","798":"0b0e985a"}[chunkId] + ".chunk.js";
};